'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        tooltipEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'tooltip.enabled'
        },
        tooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.format'
        },
        tooltipTemplate: {
            type: String,
            default: undefined,
            kComposite: 'tooltip.template'
        }
    }
};